import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import "../App.css";
import Flag from "../assets/images/flag.png";
import { useDispatch } from "react-redux";
import { forgotOtp, sendOtp } from "../redux/actions/authAction";
import { toast } from "react-toastify";
import Logo from "../assets/images/bayin.png";

const initialState={
    email:"",
    errors:{},
    loading:false,
}

const ForgotPassword = () => {

  
    const dispatch=useDispatch();
    const navigate=useNavigate();
    const [iState,updateState]=useState(initialState)
    const {email,errors,loading}=iState;

    const handleInputChange = (e) => {
        const {name,value}=e.target;
        updateState({
            ...iState,
            [name]: value,
        })
    }


    let handleValidation = () => {
        let error = {};
        let formIsValid = true;

        if (!email.trim()) {
            error.emailError = "*E-mail ID can't be empty";
            formIsValid = false;
        }
        updateState({
            ...iState,
            errors: error,
        });
        return formIsValid;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        let formIsValid = handleValidation();
        if (formIsValid) {
            updateState({...iState,loading:true})
            // const data = { storeName, description, address, email, mobileNumber, logo, banner, storeCategory, openTime, closeTime, overAllDiscount, minOrderValue, lat: "28.6260606", long: "77.3668853" }
            dispatch(forgotOtp({email}))
                .then((res) => {

                    if (res.status === 200) {
                        window.localStorage.setItem('emailId', JSON.stringify(email))
                        toast.success(res.message, {
                            position: toast.POSITION.TOP_RIGHT,
                        });

                        navigate("/otp-verification");
                        updateState({ ...iState,loading:false });
                    } else {
                        toast.error(res.message, {
                            position: toast.POSITION.TOP_RIGHT,
                        })
                        updateState({ ...iState,loading:false });
                    }
                })
                .catch((err) => {
                    const message =
                        err?.response?.data
                            ? err?.response?.data?.message
                            : "Something went wrong.";
                    toast.error(message, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                });

        }
    };


    return (
        <div>
            <div class="LoginArea" >
               
                <div class="LoginBox">
                <figure>
                    <img src={Logo} />
                </figure>
                    <span className="Language">
                    <aside>
                    <img src={Flag} />
                    </aside>
                    <select className="form-control">
                        <option>English</option>
                        <option>Arabic</option>
                    </select>
                </span>
                    <h3>Forgot  Your Password</h3>
                    <h4>No Problem! Just provide your e-mail<br />
                        address and we’ll send you a reset OTP.</h4>
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label>E-mail</label>
                            <input type="email" className="form-control" placeholder="E-mail" name='email' value={email} onChange={handleInputChange}/>
                            <span style={{ color: "red", fontSize: "12px" }}>{errors.emailError}</span>
                        </div>
                        <button className="Button" disabled={loading}>Send OTP</button>
                        {/* <Link to="/otp-verification" className="Button">Send OTP</Link> */}
                    </form>
                </div>
            </div>
          
        </div>
    );
}
export default ForgotPassword